import { Link } from 'react-router-dom';

export default function ShopByPet() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-2">
            Pick Your Player
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">Find the perfect toys for your furry teammate</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {/* Dogs */}
          <Link
            to="/shop?pet=dog"
            className="group relative rounded-2xl overflow-hidden aspect-[4/3] md:aspect-[3/2]"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Happy%20dog%20surrounded%20by%20eco-friendly%20natural%20rubber%20toys%20and%20chew%20bones%20on%20sand%20cream%20backdrop%2C%20warm%20lighting%2C%20lifestyle%20product%20photography%2C%20premium%20pet%20brand%20aesthetic%2C%20clean%20composition&width=900&height=600&seq=shop-dog-tile-01&orientation=landscape"
              alt="Dog collection"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <div className="flex items-center gap-2 mb-1">
                <span className="w-3 h-3 bg-accent-500 rounded-full"></span>
                <span className="text-background-50/80 text-xs uppercase tracking-widest font-semibold">For Dogs</span>
              </div>
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-background-50">Chew, Fetch &amp; Play</h3>
              <p className="text-background-50/70 text-sm mt-1">Toys built for real chewing and active play</p>
            </div>
          </Link>

          {/* Cats */}
          <Link
            to="/shop?pet=cat"
            className="group relative rounded-2xl overflow-hidden aspect-[4/3] md:aspect-[3/2]"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20cat%20playing%20with%20natural%20bamboo%20and%20feather%20toys%20on%20sand%20cream%20backdrop%2C%20warm%20lighting%2C%20lifestyle%20product%20photography%2C%20premium%20pet%20brand%20aesthetic%2C%20clean%20composition&width=900&height=600&seq=shop-cat-tile-01&orientation=landscape"
              alt="Cat collection"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <div className="flex items-center gap-2 mb-1">
                <span className="w-3 h-3 bg-accent-500 rounded-full"></span>
                <span className="text-background-50/80 text-xs uppercase tracking-widest font-semibold">For Cats</span>
              </div>
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-background-50">Pounce, Scratch &amp; Hunt</h3>
              <p className="text-background-50/70 text-sm mt-1">Enrichment toys that bring out their wild side</p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}